// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3lW-X","detailsBorder":"styles_detailsBorder__16Ihr"};